import { makeAttachedBlock } from "../attachedBlock";

const block = makeAttachedBlock(
  "attached-steps",
  "The user is referring to these steps of the current workflow (by name):"
);

export const buildAttachedStepsBlock = block.build;
export const prependAttachedSteps = block.prepend;
export const attachedStepNames = block.names;
export const stripAttachedStepsBlock = block.strip;
